import Drawable from '../entities/Drawable.js';
import { imageStore } from '../images.js';
import Sprite from './Sprite.js';
import PixelText from './PixelText.js';
import { c } from '../setup.js';
import { getOSM } from '../OverworldAnimation.js';

const RECT_X = 16;
const RECT_WIDTH = 208;
const RECT_HEIGHT = 10;
const PAGE_SELECTOR_Y = 27;
const FIRST_OPTION_Y = 56;
const OPTION_ROW_HEIGHT = 10;

export default class OptionsMenuUI extends Drawable {
    constructor({ stateMachine }) {
        super();
        this.stateMachine = stateMachine;
        this.visible = false;

        this.backgroundSprite = new Sprite({
            position: { x: 0, y: 0 },
            image: imageStore.get('img/menus/options_background.png'),
            moving: false,
            frames: { max: 1, val: 0 },
            visible: true,
        });
    }

    getYForOptionIndex(optionIndex) {
        if (optionIndex === 0) {
            return PAGE_SELECTOR_Y;
        }
        return FIRST_OPTION_Y + (optionIndex - 1) * OPTION_ROW_HEIGHT;
    }

    draw() {
        if (!this.visible) {
            return;
        }

        const osm = getOSM();
        const optionsMenu = osm && osm.optionsMenu;
        if (!optionsMenu) {
            return;
        }

        // Full-screen overlay: use fixed screen position (0, 0) so menu is not offset by camera
        const pos = { x: 0, y: 0 };

        this.backgroundSprite.position.x = pos.x;
        this.backgroundSprite.position.y = pos.y;
        if (this.backgroundSprite.image && typeof this.backgroundSprite.image.then !== 'function') {
            this.backgroundSprite.draw();
        }

        const options = optionsMenu.getVisibleOptions();
        const scrollOffset = optionsMenu.getScrollOffset();
        const selectedIndex = optionsMenu.currentOptionIndex;
        const selectedIndexInWindow = selectedIndex - scrollOffset;

        for (let i = 0; i < options.length; i++) {
            const option = options[i];
            const y = this.getYForOptionIndex(i);
            const drawY = pos.y + y;

            if (i === selectedIndexInWindow) {
                c.fillStyle = 'white';
                c.fillRect(pos.x + RECT_X, drawY, RECT_WIDTH, RECT_HEIGHT);
            }

            const nameText = new PixelText({
                text: option.isPageSelector ? option.value : option.name + ':',
                position: { x: pos.x + RECT_X, y: drawY + 1 },
                color: 'black',
                textAlign: 'left',
            });
            nameText.draw();

            if (!option.isPageSelector) {
                const valueText = new PixelText({
                    text: option.value,
                    position: { x: pos.x + RECT_X + RECT_WIDTH, y: drawY + 1 },
                    color: 'black',
                    textAlign: 'right',
                });
                valueText.draw();
            }
        }
    }
}
